import { lazy, Suspense } from 'react'

const MoneyflowSummaryModal = lazy(() => import('../modals/MoneyflowSummaryModal/MoneyflowSummaryModal.tsx')
    .then((module) => ({ default: module.MoneyflowSummaryModal })))
const MoneyflowVersionsModal = lazy(() => import('../modals/MoneyflowVersionsModal/MoneyflowVersionsModal.tsx')
    .then((module) => ({ default: module.MoneyflowVersionsModal })))

export const Modals = () => (
    <Suspense fallback={null}>
        <MoneyflowVersionsModal />
        <MoneyflowSummaryModal />
    </Suspense>
)
